import axios, { AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import { fetchProfileFailure, fetchProfileSuccess } from "./actions";
import { IProfile } from "./types";
import { FETCH_PROFILE_REQUEST } from "./action-types";
import { logout } from "../auth/actions";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

function* fetchProfile(action: any) {
  try {
    const token = action.payload.token;
    const response: AxiosResponse<IProfile> = yield call(
      axios.get,
      `${API_URL}/users/profile`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    yield put(
      fetchProfileSuccess({
        profiles: response.data,
      })
    );
  } catch (error: any) {
    if (error.response && error.response.status === 401) {
      yield put(logout());
      yield put(
        fetchProfileFailure({ error: "Token expired or unauthorized" })
      );
    } else {
      yield put(logout());
      yield put(fetchProfileFailure({ error: "An error occurred" }));
    }
  }
}

function* profileSaga() {
  yield all([takeLatest(FETCH_PROFILE_REQUEST, fetchProfile)]);
}

export default profileSaga;
